function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
app.views.popupExtension = app.views.base.extend(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  //#region variables

  childEvents: {
    'mousedown': 'onClickDocument_closeAllPopups',
    'click [data-close]': 'onClickCloseBtn_closePopup',
    'keydown [data-close]': 'onKeyDownCloseBtn_closePopup',
    'keydown [data-popup-submit]': 'onKeyDownSubmitBtn_closePopup'
  },
  attr: {
    popUp: 'data-popup',
    popUpContent: 'data-popup-content',
    popUpContainer: 'data-popup-container',
    popUpPlaceholder: 'data-popup-placeholder',
    spinner: 'data-spinner'
  },
  templates: {
    popUp: {
      key: 'PopUp',
      value: '<div data-popup-container><div class="payment-adjustment" data-popup>' + '<span class="payment-adjustment__overlay"></span>' + '<div class="payment-adjustment__content" data-popup-content></div></div></div>'
    },
    offerOverlay: {
      key: 'OfferOverlay',
      value: '<div data-popup-container><div class="payment-adjustment" data-popup>' + '<span class="payment-adjustment__overlay"></span>' + '<div class="payment-adjustment__content offer-overlay" data-popup-content></div></div></div>'
    },
    offerCardInput: {
      key: 'OfferCardInput',
      value: '<div data-popup-container><div class="payment-adjustment" data-popup>' + '<span class="payment-adjustment__overlay"></span>' + '<div class="payment-adjustment__content-offer-card" data-popup-content></div></div></div>'
    },
    spinner: '<div class="form-spinner" data-spinner><span class="spinner"></span></div>',
    placeholder: '<div data-popup-placeholder></div>'
  },
  //#endregion variables

  //#region init

  init: function init() {},
  //#endregion init

  //#region event listeners

  onClickCloseBtn_closePopup: function onClickCloseBtn_closePopup(e) {
    var _this = this;
    e.preventDefault();
    _this._removeOpenPopUp(e);
  },
  onKeyDownCloseBtn_closePopup: function onKeyDownCloseBtn_closePopup(e) {
    var _this = this;

    // SHIFT-TAB or ENTER
    if (e.which === 9 && e.shiftKey || e.which === 13) {
      _this._removeOpenPopUp(e);
    }
  },
  onKeyDownSubmitBtn_closePopup: function onKeyDownSubmitBtn_closePopup(e) {
    var _this = this;

    // TAB
    if (e.which === 9 && !e.shiftKey) {
      _this._removeOpenPopUp(e);
    }
  },
  onClickDocument_closeAllPopups: function onClickDocument_closeAllPopups(e) {
    var _this = this;
    if ($(e.target).closest('[' + _this.attr.popUpContainer + ']').length == 0 && !$(e.target).is('[' + _this.attr.popUpContainer + '] button')) {
      $('[' + _this.attr.popUpContainer + ']').each(function () {
        $(this).replaceWith(_this.templates.placeholder);
      });
    }
  },
  //#endregion event listeners

  //#region callable functions

  showPopUp: function showPopUp(e, url) {
    var _this = this;
    // If more than one '[data-popup-container]' in view, specify selector for container
    _this.showPopUp(e, url, null, null);
  }
}, "showPopUp", function showPopUp(e, url, container) {
  var _this = this;
  _this._showPopUp(e, url, container, null);
}), "_showPopUp", function _showPopUp(e, url, container, templateType) {
  var _this = this;
  e.preventDefault();
  if (container == null) container = $('body').find('[' + _this.attr.popUpPlaceholder + ']');
  var template;
  if (templateType === _this.templates.offerCardInput.key) template = _this.templates.offerCardInput.value;else if (templateType === _this.templates.offerOverlay.key) template = _this.templates.offerOverlay.value;else if (templateType === _this.templates.popUp.key) template = _this.templates.popUp.value;else template = _this.templates.popUp.value;
  if ($(_this).data('requestRunning')) return;else $(_this).data('requestRunning', true);
  $.ajax({
    type: 'GET',
    url: url,
    cache: false,
    beforeSend: function beforeSend() {
      $('body').find('[' + _this.attr.popUp + ']').each(function () {
        $(_this).remove();
      });
      var parent = container.parent();
      container.replaceWith(template);
      container = parent.find('[' + _this.attr.popUpContainer + ']');
      updateSpinner();
    },
    success: function success(data) {
      container.find('[' + _this.attr.popUpContent + ']').append(data);
      updateSpinner();
      app.initElementListeners(container);
      var inputField = container.find('[' + _this.attr.popUpContent + ']').find("input:first");
      if (inputField.length > 0) inputField.focus();
      container.find('[' + _this.attr.popUpContent + ']')[0].scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    },
    complete: function complete() {
      $(_this).data('requestRunning', false);
    },
    error: function error(xhr, text, exception) {
      app.helpers.throwError(xhr, text, exception);
    }
  });
  function updateSpinner() {
    var popUp = container.find('[' + _this.attr.popUpContent + ']');
    var spinner = $(popUp.find('[' + _this.attr.spinner + ']'));
    if (spinner.length > 0) spinner.remove();else {
      popUp.append(_this.templates.spinner);
      $(popUp.find('[' + _this.attr.spinner + ']')).show();
    }
  }
}), "showOfferCardInputPopup", function showOfferCardInputPopup(e, url, container) {
  var _this = this;
  _this._showPopUp(e, url, container, _this.templates.offerCardInput.key);
}), "showOfferOverlayPopup", function showOfferOverlayPopup(e, url) {
  var _this = this;
  _this.showOfferOverlayPopup(e, url, null);
}), "showOfferOverlayPopup", function showOfferOverlayPopup(e, url, container) {
  var _this = this;
  _this._showPopUp(e, url, container, _this.templates.offerOverlay.key);
}), "_removeOpenPopUp", function _removeOpenPopUp(e) {
  var _this = this;
  $('[' + _this.attr.popUpContainer + ']').each(function () {
    $(this).replaceWith(_this.templates.placeholder);
  });
}));